import user from './user'
import service from './service'

export default {
  user,
  service
}
